<template>
    <collapsible-card :title="'Lease Information'" class="infoWidth" v-show="showInfo" ref="cCard">
        <div class="cardContent">
            <div class="info2Cols">
                <div v-if="general.length > 0 || operator" class="category">
                    <h3 class="categoryTitle">General</h3>
                    <div v-if="operator">
                        <p v-if="operShort">Operator: <router-link :to="{name: 'Operators', params: {operator: operShort}}" class="link"><span class="dataEmphasis">{{operator}}</span></router-link></p>
                        <p v-else>Operator: <span class="dataEmphasis">{{operator}}</span></p>
                    </div>
                    <div v-for="obj in general" :key="obj.field" class="dataItem">
                        <p v-if="obj.val">{{obj.field}}: <span class="dataEmphasis">{{obj.val}}</span></p>
                        <p v-else><span class="dataEmphasis">{{obj.field}}</span></p>
                    </div>
                </div>
                <div v-if="dates.length > 0" class="category">
                    <h3 class="categoryTitle">Dates</h3>
                    <div v-for="obj in dates" :key="obj.field" class="dataItem">
                        <p v-if="obj.val">{{obj.field}}: <span class="dataEmphasis">{{obj.val}}</span></p>
                        <p v-else><span class="dataEmphasis">{{obj.field}}</span></p>
                    </div>
                </div>
            </div>
            <div v-if="lastRemark" class="infoVerticalSpacing">
                <h3 class="categoryTitle">Last Remark</h3>
                <p><span class="dataEmphasis">{{lastRemark}}</span></p>
                <div class="note">
                    <p>
                        Last remark made on {{lastRemarkDate}}
                    </p>
                </div>
            </div>
        </div>
    </collapsible-card>
</template>

<script>
import { readFromObj, formatDateLT } from '../../helpers/Formatting.js';
import CollapsibleCard from '../CollapsibleCard.vue';

export default {
    name: 'lease-info',
    components: {
        CollapsibleCard
    },
    data: () => ({
        showInfo: false,
        operShort: "",
        operator: "",
        general: [],
        dates: [],
        lastRemark: "",
        lastRemarkDate: ""
    }), 
    methods: {
        updateInfo: function(leaseInfo) {
            var globv = this;
            if (leaseInfo['operShort'])
                globv.operShort = leaseInfo['operShort'];
            
            if (leaseInfo['operator'])
                globv.operator = leaseInfo['operator'];

            let expectedVariables = [
                {
                    varName: "block",
                    fieldName: "Block"
                },
                {
                    varName: "protraction",
                    fieldName: "Protraction"
                },
            ]

            globv.general = readFromObj(leaseInfo, expectedVariables);

            expectedVariables = [
                {
                    varName: "effectiveDate",
                    fieldName: "Effective Date",
                    format: formatDateLT
                },
                {
                    varName: "expiry.date",
                    fieldName: "Expiry Date",
                    format: formatDateLT
                },
                {
                    varName: "expiry.days",
                    fieldName: "Days until Expiry"
                },
            ]

            globv.dates = readFromObj(leaseInfo, expectedVariables);

            if (leaseInfo['lastRemark']) {
                if (leaseInfo['lastRemark']['remark'])
                    globv.lastRemark = leaseInfo['lastRemark']['remark'];

                if (leaseInfo['lastRemark']['date'])
                    globv.lastRemarkDate = formatDateLT(leaseInfo['lastRemark']['date']);
            }

            globv.showInfo = globv.operator || globv.general.length > 0 || globv.dates.length > 0 || globv.lastRemark;
            globv.$refs.cCard.adjustHeight();
        }
    }
}
</script>

<style lang="scss">
.infoWidth {
    max-width: 750px;
}

.infoVerticalSpacing {
    margin-top: 10%;
}
</style>